import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { CheckIcon } from '@heroicons/react/24/outline'
import React, { useState } from 'react'



const Modal = ({ showModal, setShowModal }) => {
  return (
    <Transition.Root show={showModal} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={setShowModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all  sm:w-full sm:max-w-2xl ">


                {/*content*/}
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-[100%] bg-[#000]  outline-none focus:outline-none p-5">
                  {/*header*/}
                  {/*body*/}

                  <div className="my-4 ">
                    <label htmlFor="name" className="block mb-2 text-[#98A2B3] text-[16px] font-semibold">Name :</label>
                    <input type="text" name="name" className="border-0 text-[#fff] h-[35px] bg-white bg-opacity-10 focus:border-emerald-200   w-full rounded" required />
                  </div>
                  <div className='my-4'>
                    <label htmlFor="name" className="block mb-2 text-[#98A2B3] text-[16px] font-semibold">Add Profile : </label>
                    <input
                      className="relative m-0 block w-full min-w-0 flex-auto rounded  bg-clip-padding bg-white bg-opacity-10 px-3 py-[0.32rem] text-base font-normal text-neutral-700 transition duration-300 ease-in-out file:-mx-3 file:-my-[0.32rem] file:overflow-hidden file:rounded-none file:border-0 file:border-solid file:border-inherit file:bg-neutral-100 file:px-3 file:py-[0.32rem] file:text-neutral-700 file:transition file:duration-150 file:ease-in-out file:[border-inline-end-width:1px] file:[margin-inline-end:0.75rem] hover:file:bg-neutral-200 focus:border-primary focus:text-neutral-700 focus:shadow-te-primary focus:outline-none dark:border-neutral-600 dark:text-neutral-200 dark:file:bg-neutral-700 dark:file:text-neutral-100 dark:focus:border-primary"
                      type="file"
                      id="formFile" />
                  </div>
                  <div className='flex items-center justify-center md:flex-nowrap flex-wrap md:space-x-5 space-x-0 md:space-y-0 space-y-5'>
                    <div className="my-4 md:w-1/2 w-full">
                      <label htmlFor="jobtitle" className="block mb-2 text-[#98A2B3] text-[16px] font-semibold">Job Title :</label>
                      <input type="text" name="jobtitle" className="border-0 text-[#fff] h-[35px] bg-white bg-opacity-10 focus:border-emerald-200   w-full rounded" required />
                    </div>
                    <div className="my-4 md:w-1/2 w-full">
                      <label htmlFor="email" className="block mb-2 text-[#98A2B3] text-[16px] font-semibold">Email : </label>
                      <input type="text" name="email" className="border-0 text-[#fff] h-[35px] bg-white bg-opacity-10 focus:border-emerald-200    w-full rounded" required />
                    </div>

                  </div>
                  <div className='flex items-center justify-center md:flex-nowrap flex-wrap md:space-x-5 space-x-0 md:space-y-0 space-y-5'>

                    <div className="my-4  md:w-1/2 w-full">
                      <label htmlFor="phoneno" className="block mb-2 text-[#98A2B3] text-[16px] font-semibold">Telephone : </label>
                      <input type="text" name="phoneno" className="border-0 text-[#fff] h-[35px] bg-white bg-opacity-10 focus:border-emerald-200    w-full rounded" required />
                    </div>
                    <div className="my-4  md:w-1/2 w-full">
                      <label htmlFor="companyname" className="block mb-2 text-[#98A2B3] text-[16px] font-semibold">Comapny Name : </label>
                      <input type="text" name="companyname" className="border-0 text-[#fff] h-[35px] bg-white bg-opacity-10 focus:border-emerald-200    w-full rounded" required />
                    </div>
                  </div>
                  <p className='text-[#98A2B3] text-[18px] font-semibold'>Do you identify as </p>
                  <div className='grid grid-cols-2 mt-2'>
                    <div>
                      <div className="flex items-start space-x-3 py-2">
                        <input type="checkbox" className="border-gray-300 bg-transparent rounded h-5 w-5" />
                        <h1 className="text-[#98A2B3] font-medium leading-none">Mentor/judge  </h1>
                      </div>
                      <div className="flex items-start space-x-3 py-2">
                        <input type="checkbox" className="border-gray-300 bg-transparent rounded h-5 w-5" />
                        <h1 className="text-[#98A2B3] font-medium leading-none">Partner (corporate or other) </h1>
                      </div>
                      <div className="flex items-start space-x-3 py-2">
                        <input type="checkbox" className="border-gray-300 bg-transparent rounded h-5 w-5" />
                        <h1 className="text-[#98A2B3] font-medium leading-none">AI expert / academic
                        </h1>
                      </div>
                    </div>
                    <div>
                      <div className="flex items-start space-x-3 py-2">
                        <input type="checkbox" className="border-gray-300 bg-transparent  rounded h-5 w-5" />
                        <h1 className="text-[#98A2B3] font-medium leading-none">Supplier</h1>
                      </div>
                      <div className="flex items-start space-x-3 py-2">
                        <input type="checkbox" className="border-gray-300 bg-transparent rounded h-5 w-5" />
                        <h1 className="text-[#98A2B3] font-medium leading-none">Start-up enthusiast  </h1>
                      </div>
                    </div>
                  </div>
                  <div className='my-3'>
                    <p className='text-[#98A2B3] text-[18px] font-semibold mb-2'>What would you like to be informed about:  </p>
                    <select className='className="border h-[40px] bg-white bg-opacity-10  text-[#fff] w-full rounded'>
                      <option value="1" className='bg-[#000]'>Up-coming events (general) </option>
                      <option value="1" className='bg-[#000]'>Hackathons and ideation jams  </option>
                      <option value="1" className='bg-[#000]'>Sponsorship opportunities  </option>
                      <option value="1" className='bg-[#000]'>Mentoring opportunities  </option>
                      <option value="1" className='bg-[#000]'>Investment opportunities and demo days  </option>
                    </select>
                  </div>
                  <div className="my-4">
                    <label htmlFor="tellusmore" className="block mb-2 text-[#98A2B3] text-[16px] font-semibold">Tell us more : </label>
                    <input type="text" name="tellusmore" className="border-0 text-[#fff] h-[35px] bg-white bg-opacity-10 focus:border-emerald-200    w-full rounded" required />
                  </div>
                  <div className="flex items-center justify-end mt-5 space-x-5">
                    <button
                      className="text-red-500 bg-[#fff] font-bold uppercase px-6 py-3 text-sm rounded outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => setShowModal(false)}
                    >
                      Close
                    </button>
                    <button
                      className="bg-white bg-opacity-10 gap-3 text-[#fff] flex justify-center items-center px-5 py-3 text-center rounded border border-transparent hover:border hover:border-[#155EEF] "
                      type="button"
                      onClick={() => setShowModal(false)}
                    >
                      Save Changes
                    </button>
                  </div>
                  {/*footer*/}
                </div>

              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

export default Modal